export default __webpack_public_path__ + "static/gaku-screen-3-a3884b53e8891af4e08ff30854b6f489.png";